import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select, InputNumber } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getSalaryAdjustmentDetails, doSalaryAdjustmentCreate, doSalaryAdjustmentUpdate 
} from "../../../../redux/salaryadjustment/salaryAdjustmentState";
import { useForm } from 'antd/lib/form/Form';
import SelectWithOthers from "components/select/selectwithothers";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../utils/crudSagaHelper';

const { TextArea } = Input;
const dateFormat = 'YYYY-MM-DD';

const SalaryAdjustmentForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	const [salaryList, setSalaryList] = useState([]);
  	const [paycodeList, setPaycodeList] = useState([]);
  	
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { sdj_effective_date, salaryList: newSalaryList, paycodeList: newPaycodeList, ...rest } = recordData;
			setSalaryList(newSalaryList || []);
			setPaycodeList(newPaycodeList || []);
	        const initialValues = {
	            ...rest,
	            sdj_effective_date: sdj_effective_date ? dayjs(sdj_effective_date, dateFormat) : null,
	        };	
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  
			formData.sdj_effective_date = formData.sdj_effective_date.format('YYYY-MM-DD');
			formData.sdj_amount = parseFloat(formData.sdj_amount);		
			recordData.sdj_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
	
	const computePerHoursAmount = () => {	
		const employee_id = form.getFieldValue('sdj_employee_id');
		const hours = form.getFieldValue('sdj_hours');	
		const paycodeId = form.getFieldValue('sdj_paycode_id');
		
		let salaryType = 38;
		let percentage = 1;
		
		if(paycodeId > 0){
			const paycode = paycodeList.find(item => item.value === paycodeId);
			if(paycode){
				if(paycode.percentage > 0){
					percentage = paycode.percentage/100;
				}
				
				if(paycodeId === 54){
					salaryType = 39;
				}
			}
		}
		
		console.log(salaryType);
		console.log(salaryList);
		if(hours && employee_id > 0){
			const employeeSalary = salaryList.find(item => item.label === employee_id && item.type === salaryType);

	        if (employeeSalary) {
	            const newAmount = ((employeeSalary.value/21.75)/8) * hours;	            
	            form.setFieldsValue({ sdj_amount: newAmount * percentage });
	        }
		}		
	}
	
	const onAmountChangeHandler = () => {
		form.setFieldsValue({ sdj_hours: 0 });
	}
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="sdj_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-4">         
		            <FormItem className="font-medium mb-2"
		            	name="sdj_employee_id"
		                label="Employee"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdj_employee_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.employeeList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
						    onChange={computePerHoursAmount}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdj_employee_name}</label>
		            	}	                
	            	</FormItem>
	            	<FormItem className="font-medium mb-2"
		            	name="sdj_effective_date"
		                label="Date"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<DatePicker className="font-normal" 
		            		format={dateFormat}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdj_effective_date}</label>
		            	}	                
	            	</FormItem>
	            	<FormItem className="font-medium mb-2 col-span-2"
		            	name="sdj_paycode_id"
		                label="Paycode"
						rules={[requiredField()]}
		            >
		            	<SelectWithOthers 
		            		mode={mode}
		            		selectFieldName="sdj_paycode_id" 
		            		selectOptions={recordData?.paycodeList} 
		            		selectDisplayValue={recordData?.sdj_paycode_code}
  							othersFieldName="sdj_other_specific"
  							othersDisplayValue={recordData?.sdj_other_specific}
  							optionOthersId={[58,59]}
  							onChangeHandler={computePerHoursAmount}
		            	/>
	            	
    				</FormItem>
	            	<FormItem className="font-medium mb-2"
		            	name="sdj_hours"
		                label="Hours"
		            >
		            	{mode === 'edit' ?		            	
		            	<InputNumber precision={2}
		                    id="sdj_hours"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
						    onChange={computePerHoursAmount}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdj_hours}</label>
		                }
	            	</FormItem>	
	            	<FormItem className="font-medium mb-2"
		            	name="sdj_amount"
		                label="Amount"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?		            	
		            	<InputNumber precision={2}
		                    id="sdj_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
						    onChange={onAmountChangeHandler}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdj_amount}</label>
		                }
	            	</FormItem>	  	            	
	            	<FormItem className="font-medium mb-2"
		            	name="sdj_type_id"
		                label="Payroll Type"
						rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdj_type_id"
		            		allowClear={true}
						    options={recordData?.payrollTypeList}
							style={{
						        width: 150,
						      }}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdj_type_name}</label>
		            	}	                
	            	</FormItem>
    				<FormItem className="font-medium mb-2"
		            	name="sdj_status_name"
		                label="Status"
		            >
		               	<label className="ps-3 dark:text-white">{recordData?.sdj_status_name}</label>
	            	</FormItem>	 
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="sdj_notes"
		                label="Notes"
		                initialValue={recordData?.sdj_notes}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		maxLength={500}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdj_notes}</label>
		                }
	            	</FormItem>
	 			</div>
	 			<CrudButtons baseRoute="/console/salary-adjustments" mode={mode} recordId={recordId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.salaryAdjustment.salaryAdjustmentDetails?.data,
  	requesting: state.salaryAdjustment.salaryAdjustmentDetails?.requesting,
  	success: state.salaryAdjustment.salaryAdjustmentDetails?.succcess,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getSalaryAdjustmentDetails(id)),
  	doCreate: (data) => dispatch(doSalaryAdjustmentCreate(data)),
  	doUpdate: (data) => dispatch(doSalaryAdjustmentUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdjustmentForm);
